// extracted by mini-css-extract-plugin
export default {"menu":"Menu-index__menu--gugJU"};